import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Card, Button, Row, Col, Form } from "react-bootstrap";
import RendicionesHistoricas from "./rendicionesHistoricas";
import RendicionCuotas from "./rendicionCuotas";
import { LoadingComponent } from 'recupero-comunes';
import { serviceGetCfgForm, serviceGetDeclaracionPago } from '../../api/api-rendicion-pago-cuotas';
import { formato_monto, isValidParam } from '../../common/Formatos'
import { obtenerDatosLlaves } from '../../store/actions/area-busqueda-ingreso-recuperos-cuota-action'

const PagoCuotas = () => {
    const dispatch = useDispatch()
    const {state} = useLocation()
    const idCaso = state?.row?.IdCaso ? state.row.IdCaso:1000058
    const idImplicado = state?.row?.IdImplicado ? state.row.IdImplicado:1
    const idOrganizacionCaso = state?.row?.IdOrganizacionCaso ? state.row.IdOrganizacionCaso:8600399880

    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);
    const [declaracionPago, setDeclaracionPago] = useState({});

    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosIngresoRecuperoReducer)
    const {llaves} = data_areaBuscar

    useEffect(() => {     
    
       dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
    
    }, [dispatch])

    const initialData = async () => {
        setLoading(true);

        await getCfgForm();
        await getDeclaracionPago();

        setLoading(false);

    }
    
    useEffect(() => {     
        initialData(); 
    }, [dispatch])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrganizacionCaso, idform: 86 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getDeclaracionPago = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado:idImplicado })).toString('base64');
        const response = await serviceGetDeclaracionPago(query);

        setDeclaracionPago(response);
    }
    return (
        <Fragment>
        <LoadingComponent show={loading} />
            <Container>
                <Card className="mb-3 p-3">
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-titleing"]) ? cfg_form["rinde-cuotas-titleing"] : 'Registro Pago Recobro en Cuotas'} - {llaves && llaves['idCaso']}
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Siniestro'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['siniestro'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Patente'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['patente'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Implicado'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['implicado'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Responsable'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['responsable'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Moneda'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['moneda'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Monto Recobro'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago && isValidParam(declaracionPago['montoRecobro']) ? formato_monto(declaracionPago['montoRecobro']) : null}
                                </Form.Text>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Convenio Pago'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['idConvenio'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Monto Pago (pie)'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago && isValidParam(declaracionPago['montoPagoPie']) ? formato_monto(declaracionPago['montoPagoPie']) : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Cantidad de Cuotas'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['nroCuotas'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Fecha Primer Pago'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['fechaPrimerPagoFormat'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Fecha Último Pago'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['fechaUltimoPagoFormat'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Recobro Cuotas'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago && isValidParam(declaracionPago['totalCuotas']) ? formato_monto(declaracionPago['totalCuotas']) : null}
                                </Form.Text>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <RendicionesHistoricas 
                    cfg_form = {cfg_form} 
                    declaracionPago={declaracionPago}
                />
                
                <RendicionCuotas             
                    cfg_form={cfg_form} 
                    declaracionPago={declaracionPago}
                    getDeclaracionPago={getDeclaracionPago}
                    />
            </Container>
        </Fragment>
    );
};
export default PagoCuotas;